
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/features/incognito-mode",
      function () {
        return require("private-next-pages/[lang]/features/incognito-mode.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/features/incognito-mode"])
      });
    }
  